import React from "react";
import { Box, IconButton, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { useGetCustomersQuery } from "state/api";
import { Header } from "components";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link,  useNavigate } from 'react-router-dom';





// Customers
const Customers = () => {
  // theme
  const theme = useTheme();
  const navigate = useNavigate();

  // get data
  const { data, isLoading } = useGetCustomersQuery();

  // data columns
  const columns = [
    {
      field: "_id",
      headerName: "ID",
      flex: 1,
    },
    {
      field: "username",
      headerName: "Username",
      flex: 0.5,
    },
    {
      field: "name",
      headerName: "Name",
      flex: 0.5,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
    },
    {
      field: "phoneNo",
      headerName: "Phone No.",
      flex: 0.5,
    },
    {
      field: "isEmoEaseInterest",
      headerName: "Yoga Interest",
      flex: 0.5, 
    },
    // {
    //   field: "phoneNumber",
    //   headerName: "Phone Number",
    //   flex: 0.5,
    //   renderCell: (params) => {
    //     return params.value.replace(/^(\d{3})(\d{3})(\d{4})/, "($1) $2-$3"); // format phone number (123) 456-7890
    //   },
    // },
    // {
    //   field: "country",
    //   headerName: "Country",
    //   flex: 0.4,
    // },
    // {
    //   field: "occupation",
    //   headerName: "Occupation",
    //   flex: 1,
    // },
    {
      field: "role",
      headerName: "Role",
      flex: 0.5,
    },
    {
      field: "subscription",
      headerName: "Subscriptions Details",
      flex: 0.5,
      renderCell: (params) => (
        <IconButton
          color="white"
          onClick={() => 
              {
                  console.log(params.row._id, 'Clickig on the row');
                  // return navigate(`/details/${params.row._id}`);
                  return navigate(`/subscriptionDetails`, {state: params.row });
              }
      
      }
        >
          <ArrowForwardIcon />
        </IconButton>
      ),
    },
  ];

  return (
    <Box m="1.5rem 2.5rem">
      {/* Header */}
      {/* <Header title="CUSTOMERS" subtitle="List of Customers" /> */}
      <Header title="USERS" subtitle="List of Users" />

      {/* Content */}
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButtom-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        {/* Grid table */}
        <DataGrid
          loading={isLoading || !data}
          getRowId={(row) => row._id}
          rows={data || []}
          columns={columns}
        />
      </Box>
    </Box>
  );
};

export default Customers;
